import { Fragment, useCallback, useEffect, useState } from 'react';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { useNotifyMessage } from '../../../hooks/useNotifyMessage';
import useConfirmDialog from '../../../hooks/useConfirmDialog';
import { CONFIRM_DIALOG_ACCOUNT_DELETE } from '../../../constants/Constants';
import AuthService from '../../../services/auth.service';
import { deleteUser } from '../../../services/user.service';

export default function Support(): JSX.Element {
  const { renderDialog, confirm } = useConfirmDialog(CONFIRM_DIALOG_ACCOUNT_DELETE);
  const { notifyMessage } = useNotifyMessage();

  const handleDeleteAccount = useCallback(async () => {
    const { accepted } = await confirm({});
    if (!accepted) return;
    const userId = (await AuthService.getUserProfile())?.UserId;
    if (userId) {
      await deleteUser(userId)
        .then(() => {
          notifyMessage('User has been removed', 'success');
          AuthService.logout();
        })
        .catch((err) => {
          notifyMessage('Unable to delete user', 'error');
          console.error('Unable to delete user', err);
        });
    }
  }, [confirm]);

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    AuthService.isAuthenticated().then((x) => setIsAuthenticated(x));
  }, []);

  return (
    <Fragment>
      {renderDialog()}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start', height: '80vh', paddingTop: 50 }}>
        <Paper elevation={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%', height: '60vh' }}>
          <Box sx={{ width: '95%' }}>
            <Typography variant='subtitle1' gutterBottom>
              Delete Account
            </Typography>

            <Typography variant='body2' gutterBottom>
              You have requested to delete your user account on the E-ULD app.
            </Typography>

            <Typography variant='subtitle2' gutterBottom style={{ marginTop: 10 }}>
              By confirming this action below, you agree that the following information will be removed from our systems permanently:
              <p style={{ paddingLeft: 10 }}>
                - User profile including personal details and contact information
                <br />- Usage history such as logging information gathered during scanning and pairing.
              </p>
            </Typography>
            <Typography variant='subtitle2' gutterBottom></Typography>

            <Typography variant='body2' gutterBottom>
              Please note that data BLE sighting data and pairing configuration data captured during the use of the app cannot be deleted as it is an
              integral part of the system configuration and audit trails.
            </Typography>

            <Typography variant='body2' gutterBottom style={{ marginTop: 10 }}>
              By confirming this action, you will lose access to the E-ULD app. This action does not affect other accounts you may have for other
              Unilode Systems.
            </Typography>
            <br />
            <Grid container spacing={3}>
              <Grid xs={12} item>
                {isAuthenticated && (
                  <>
                    <Button variant='contained' color='warning' size='small' onClick={() => handleDeleteAccount()}>
                      Confirm - Delete my Account and Personal Information
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </div>
    </Fragment>
  );
}
